export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 20;
export const KEY = "eb968601-ccf2-4582-ae35-7eb1ea7ca482";
export const MODAL_CLOSE_SEC = 1.5;
